import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=fa4619ec&scoped=true&"
import script from "./landing.vue?vue&type=script&lang=js&"
export * from "./landing.vue?vue&type=script&lang=js&"
import style0 from "./landing.vue?vue&type=style&index=0&id=fa4619ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4619ec",
  null
  
)

export default component.exports